import React from "react";
import dayjs from "dayjs";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import DataPickerCst from "@components/InputCst/DataPickerCst";
import { WizardStepProps } from "@components/WizardCst/types";
import { ActivityWizardData } from "../../../types";
import ToggleSection from "./ToggleSection";

const toUtcMidnightISO = (input: Date | string | number): string => {
  const d = new Date(input);
  const utcMs = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0);
  return new Date(utcMs).toISOString();
};

const ObsolescenceSection: React.FC<WizardStepProps<ActivityWizardData>> = ({
  data,
  setData,
  errors,
}) => {
  const { t } = useTranslation("wizard-activity");

  const errMsg = (key: string): string =>
    errors[key] ? t(`errors.${errors[key]}`) || "" : "";

  const handleToggle = (next: boolean) => {
    setData({ schedule_obsolescence: next, obsolescent_date: null });
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <ToggleSection
        question={t("sections.obsolescence.question")}
        description={t("sections.obsolescence.description") || undefined}
        checked={data.schedule_obsolescence}
        onChange={handleToggle}
        noLabel={t("common.no") || "No"}
        yesLabel={t("common.yes") || "Sì"}
      />

      {data.schedule_obsolescence && (
        <Box>
          <DataPickerCst
            id="activity-obsolescent-date"
            label={`${t("fields.obsolescent-date")} *`}
            value={data.obsolescent_date ?? null}
            onChange={(value: any) => {
              if (value && !dayjs(value).isValid()) return;
              setData({
                obsolescent_date: value ? toUtcMidnightISO(value) : null,
              });
            }}
            error={!!errors.obsolescent_date}
            errorMessage={errMsg("obsolescent_date")}
          />
        </Box>
      )}
    </Box>
  );
};

export default ObsolescenceSection;
